import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler,HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './auth.service';
import {Observable, BehaviorSubject} from "rxjs";
//import { catch } from "rxjs/operators";



@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
    // Refresh Token Subject tracks the current token, or is null if no token is currently
    // available (e.g. refresh pending).
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
      null
  );
  
  constructor(public auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler):                   
  Observable<HttpEvent<any>> {
    return next.handle(request)
       .pipe(
           data  => { alert(data); return data;},
           error => {
           // We don't want to refresh token for some requests like login or refresh token itself
            // So we verify url and we throw an error if it's the case
           if (
                request.url.includes("refresh") ||
                request.url.includes("login")
            ) {
                // We do another check to see if refresh token failed
                // In this case we want to logout user and to redirect it to login page

                if (request.url.includes("refreshtoken")) {
                    this.auth.logout();
                }

                return Observable.throw(error);
            }
        return Observable.throw(error);
       });

    }
}